<template>
  <div class="wrapper" data-app>
    <div v-show="item?.is_cancel !== 1">
      <img
        v-if="item?.can_payment !== 1"
        :src="icons.icon_circle"
        width="18px"
      />
      <img v-if="item?.can_payment === 1" :src="bg.icon_checked" width="20px" />
    </div>
    <img
      v-show="item?.is_cancel === 1"
      src="@/assets/img/svg/checkbox_cancel.svg"
      width="18px"
    />
  </div>
</template>

<script>
import { formatNumber } from "@/plugins/init";
import { getBackGround } from "@/utils/wapAuth";

export default {
  components: {}, //, Comment
  bodyClass: "data-detail-services",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bg: getBackGround()
    };
  },
  created() {},

  watch: {},

  methods: {
    formatNumber
  },
  computed: {},
  mounted() {},

  beforeDestroy() {}
};
</script>
